<template lang="html">
  <v-card class="px-3 py-3">
    <v-progress-linear :indeterminate="true"></v-progress-linear>
    <h3>Connecting with your Quickbooks account</h3>
  </v-card>
</template>

<script>
import API from '@/api';
import firebase from 'firebase';

export default {
  name: 'QBAuth',
  props: {
    code: {
      type: String,
    },
    companyId: {
      type: String,
    },
    realmId: {
      type: String,
    },
  },
  methods: {
    async closeWindow() {
      const dbPath = localStorage.getItem('QbMessagePath');
      const dbRef = firebase.database().ref(`message_list/${this.companyId}/${dbPath}`);
      await dbRef.set({ refresh: true })
        .then(f => {}, u => console.error('Rejected writing the thing', u))
        .catch(r => console.error('Did not Write the thing [error edition]', r));

      window.close();
    },
  },
  mounted() {
    try {
      API.quickBooks.saveAuthentication({
        code: this.code,
        companyId: this.companyId,
        realmId: this.realmId,
      }).then(() => {
        this.closeWindow();
      });
    } catch (e) {
      this.closeWindow();
    }
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/Companies/QBAuth.vue